import styled, { css } from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

export const Wrapper = styled.div`
  background-color: white;
  ${fonts.libreBaskerville};
`

export const Content = styled.div`
  max-width: 860px;
  margin: 0 auto;
  display: flex;
  flex: 1;
  justify-content: space-between;
  @media (max-width: 880px) {
    padding: 30px 0px;
    justify-content: center;
  }
`

export const Image = styled.div`
  height: 300px;
  width: 300px;
  flex-shrink: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: ${props => `url(${props.src})`};
  @media (max-width: 880px) {
    display: none;
  }
`

export const Information = styled.div`
  padding-top: 30px;
  padding-right: 30px;
  font-size: 17px;
`

export const Title = styled.h1`
  color: ${colors.pink};
  font-size: 24px;
`

export const Text = styled.span`
  > a {
    color: ${colors.darkPurple};
  }
  ${props => css`
    color: ${props.color || colors.pink};
    font-size: ${props.small ? '14px' : '17px'};
  `}
`

export const List = styled.ul`
  color: ${colors.darkPurple};
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: 15px;
  padding: 0;
  list-style-type: none;
`

export const Item = styled.li`
  position: relative;
  width: 50%;
  :before {
    position: absolute;
    left: -10px;
    top: calc(50% - 3px);
    height: 6px;
    width: 6px;
    border-radius: 50%;
    background-color: ${colors.yellow};
    content: '';
  }
`
